import { render, staticRenderFns } from "./vc-checkbox.vue?vue&type=template&id=5bfbb655&scoped=true&"
import script from "./vc-checkbox.vue?vue&type=script&lang=js&"
export * from "./vc-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./vc-checkbox.vue?vue&type=style&index=0&id=5bfbb655&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfbb655",
  null
  
)

export default component.exports